import { useEffect } from "react";
import "./mobile-warning.css";

const DEFAULT_TITLE = "Niet gemaakt voor mobiel";
const DEFAULT_BODY =
  "Deze tool is ontworpen voor gebruik op tablet of computer. Op je telefoon werkt niet alles even goed — maar je mag gerust even rondkijken.";

export interface MobileWarningModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  body?: string;
}

export function MobileWarningModal({
  open,
  onClose,
  title = DEFAULT_TITLE,
  body = DEFAULT_BODY,
}: MobileWarningModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="jari-mobile-warning-backdrop"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mobile-warning-title"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="jari-mobile-warning">
        <p className="jari-mobile-warning__label">Tip</p>
        <h2 id="mobile-warning-title">{title}</h2>
        <p>{body}</p>
        <div className="jari-mobile-warning__actions">
          <button type="button" className="jari-btn jari-btn--primary" onClick={onClose}>
            Begrepen
          </button>
        </div>
      </div>
    </div>
  );
}
